import { ReactComponent as Logo } from "../../vendor/logo_black.svg";
import { gql, useMutation } from "@apollo/client";
import { Alert as MuiAlert, Button, Paper, Typography } from "@mui/material";
import { spacing } from "@mui/system";
import useAuth from "hooks/useAuth";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components/macro";

const Alert = styled(MuiAlert)(spacing);

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 250px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

export const VERIFY_ACCOUNT_MUTATION = gql`
  mutation VerifyAccount($token: String!) {
    verifyAccount(token: $token) {
      success
      errors
    }
  }
`;

const ActivateAccount = () => {
  const token = useParams().token;
  const { reloadUser } = useAuth();
  const [verifyAccount, { data, loading, error }] = useMutation(
    VERIFY_ACCOUNT_MUTATION
  );

  useEffect(() => {
    if (token) {
      verifyAccount({ variables: { token } })
        .then((result) => {
          if (result.data?.verifyAccount?.success) {
            reloadUser().catch(() => undefined);
          }
        })
        .catch(() => undefined);
    }
  }, [token, verifyAccount, reloadUser]);

  const activationFailed = error || (data && !data.verifyAccount.success);

  return (
    <>
      <Brand />
      <Wrapper>
        <Helmet title="Activate Account" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Account activation
        </Typography>

        {loading && (
          <Alert my={2} severity="info">
            Activating your account...
          </Alert>
        )}

        {activationFailed && (
          <Alert my={2} severity="warning">
            Sorry, there was an error activating your account. Please contact us
            at <a href="mailto:support@podium.live">support@podium.live</a>.
          </Alert>
        )}

        {data && data.verifyAccount.success && (
          <Alert my={2} severity="success">
            Your account has been activated.
          </Alert>
        )}

        <Button component={Link} to="/auth/sign-in" fullWidth color="primary">
          Sign in
        </Button>
      </Wrapper>
    </>
  );
};

export default ActivateAccount;
